
import { useContext } from 'react';
import { Link, useParams } from 'react-router';

import SearchBox from 'src/components/SearchBox';

import Logo from 'src/components/Logo';
import logoVet from '/img/imago_veterinaria.svg'

import 'src/css/Header.scss';

const Header = () => {
    const { id } = useParams();
    return (
        <div id="header" className={` ${id ? 'head-search' : ''}`}>
            <Logo />

            {id && <SearchBox /> }

            <div className="logo _r">
                <Link to="/" className="no-txt"> <span>Ir a Home</span> <img src={logoVet} alt="Logo Veterinaria"/> </Link>
            </div>
        </div>
    );
};

export default Header;
